import React from "react";

const DrivingBusinessExcellenceAndEfficiency = ({ sustainability_driving }) => {
  const {
    title_heading,
    title_one,
    description_one,
    title_two,
    description_two,
  } = sustainability_driving;
  return (
    <div
      className="pt-5 pb-5"
      id="our-commitment"
      data-aos="fade-up"
      data-aos-duration="3000"
    >
      <h3 className="fs-30 lh-40 mb-4">{title_heading}</h3>
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item accordion-box-shadow border">
          <h2
            className="accordion-header p-4 accordion-box-shadow"
            id="flush-headingOne"
          >
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              <span className="fs-14 gilroy-bold text-orange-ryb">
                {title_one}
              </span>
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body ms-4">
              <span
                className="fs-16"
                dangerouslySetInnerHTML={{ __html: description_one }}
              />
            </div>
          </div>
        </div>
        <div className="accordion-item mt-4 accordion-box-shadow border">
          <h2
            className="accordion-header p-4 accordion-box-shadow"
            id="flush-headingTwo"
          >
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            >
              <span className="fs-14 gilroy-bold text-orange-ryb">
                {title_two}
              </span>
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingTwo"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body ms-4">
              <span
                className="fs-16"
                dangerouslySetInnerHTML={{ __html: description_two }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrivingBusinessExcellenceAndEfficiency;
